import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-mail-form-v3.component.scss";
var FormItemMailFormV3 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMailFormV3, _super);
    function FormItemMailFormV3(element) {
        return _super.call(this, element) || this;
    }
    FormItemMailFormV3.prototype.init = function () {
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".dataSharingGroup-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".dataSharingGroup-show-btn");
        this.dataSharingGroupTextArea =
            this.element.querySelector(".dataSharingGroup");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".dataSharing3rdParty-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".dataSharing3rdParty-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".dataSharing3rdParty");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".dataSharingBoarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".dataSharingBoarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".dataSharingBoarders");
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.subjectField = this.element.querySelector("input[name=subject]");
        this.emailField = this.element.querySelector("input[name=email]");
        this.recipientField = this.element.querySelector("input[name=recipient]");
    };
    FormItemMailFormV3.prototype.bindEvents = function () {
        var _this = this;
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
                _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
                _this.dataSharingGroupShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute("hidden");
                _this.dataSharingGroupHideBtn.removeAttribute("hidden");
                _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
                _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute("hidden");
                _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
            });
        }
        this.applyFormSubmit.map(function (item) {
            return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        });
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
    };
    FormItemMailFormV3.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            var formContainerLoader = this.element.querySelector(".form__loader--container");
            var formContainerFields = this.element.querySelector(".form__fields--container");
            var formContainerThankyou = this.element.querySelector(".form__thankyou--container");
            var complaintsDeclined = this.element.querySelector(".form-container-complaints__declined");
            formContainerThankyou.classList.remove("active");
            formContainerFields.classList.remove("hidden");
            var _complaintsProcessWrap = this.element.querySelector(".complaints-process-wrapper");
            if (_complaintsProcessWrap) {
                _complaintsProcessWrap.classList.add("form__group--hidden");
            }
            if (complaintsDeclined) {
                complaintsDeclined.classList.add("hidden");
            }
        }
    };
    FormItemMailFormV3.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemMailFormV3.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/genericform.jsp";
        var _recipient = this.applyForm.querySelector("input[name=recipient]");
        var _email = this.applyForm.querySelector("input[name=email]");
        var _subject = this.applyForm.querySelector("input[name=subject]");
        var _redirect = this.applyForm.querySelector("input[name=redirect]");
        var _name = this.applyForm.querySelector("input[name=name]");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        var _emailAddress = this.applyForm.querySelector("input[name=email-address]");
        var _businessName = this.applyForm.querySelector("input[name=business-name]");
        var _phoneNumber = this.applyForm.querySelector("input[name=phone-number]");
        var _numberOfVehicles = this.applyForm.querySelector("input[name=number-of-vehicles]");
        var _requestType = this.applyForm.querySelector("select[name=request-type]");
        var _comment = this.applyForm.querySelector("textarea[name=comment]");
        var _product = this.applyForm.querySelector("input[name=product]");
        var _termsAndConditions = this.applyForm.querySelector("input[name=terms-and-conditions]");
        var _dataPrivacyConsent = this.applyForm.querySelector("input[name=dataPrivacyConsent]");
        var _postData = {
            recipient: _recipient ? _recipient.value : "",
            email: _email ? _email.value : "",
            subject: _subject ? _subject.value : "",
            redirect: _redirect ? _redirect.value : "",
            firstname: _name ? _name.value : "",
            surname: _surname ? _surname.value : "",
            emailAddress: _emailAddress ? _emailAddress.value : "",
            "business-name": _businessName ? _businessName.value : "",
            contactNo: _phoneNumber ? _phoneNumber.value : "",
            "number-of-vehicles": _numberOfVehicles
                ? _numberOfVehicles.value
                : "",
            "request-type": _requestType ? _requestType.value : "",
            comment: _comment ? _comment.value : "",
            product: _product ? _product.value : "",
            "terms-and-conditions": _termsAndConditions
                ? _termsAndConditions.value
                : "",
            dataPrivacyConsent: _dataPrivacyConsent && _dataPrivacyConsent.checked
                ? "YES"
                : "NO",
            dataSharingGroup: this.getDataConsentValue(form, "dataSharingGroup"),
            dataSharing3rdParty: this.getDataConsentValue(form, "dataSharing3rdParty"),
            dataSharingBoarders: this.getDataConsentValue(form, "dataSharingBoarders"),
        };
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        this.formsService
            .postForm(url, this.http.serialiseObject(_postData))
            .then(function (response) {
            // service ok
            loader.classList.remove("active");
            analyticsService.dtmFormComplete("complete", response.code, false, "", _emailAddress.value, _phoneNumber.value);
            thankYou.classList.add("active");
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            thankYou.classList.add("active");
        });
    };
    return FormItemMailFormV3;
}(Base));
export { FormItemMailFormV3 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-mail-form-v3/form-item-mail-form-v3.component.ts
// module id = 1009
// module chunks = 0